export default {
      id: "link-18-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite-46b249.svg#link-18-usage",
      toString: function () {
        return this.url;
      }
    }